import HTTP_CODES_ENUM from "./types/http-codes";

const FIRST_NON_SUCCESS_STATUS = 300;

export const isSuccessStatus = (status: number) =>
    status >= HTTP_CODES_ENUM.OK && status < FIRST_NON_SUCCESS_STATUS;
